import React, { useEffect, useState } from 'react';
import '../css/lineLiff.css'
import liff from '@line/liff';
import { toast } from 'react-toastify';
import axios from 'axios';
import exampleImage from "../../no-image.webp";
export default function LineLiff() {

  const [getIdToken, setGetIdToken] = useState("");
  const [checkLineProfile, setcheckLineProfile] = useState(0);
  const [checkLineProfileRegistered, setcheckLineProfileRegistered] = useState(0);

  const [formData, setFormData] = useState({
    pictureUrl: exampleImage,
    displayName: '',
    email: '',
    telephone: '',
  });

  const { pictureUrl, displayName, email, telephone } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    const initLiff = async () => {
      try {
        await liff.init({ liffId: process.env.REACT_APP_LIFF_ID });

        if (!liff.isLoggedIn()) {
          liff.login();
        } else {
          const getIDToken = liff.getIDToken();
          setGetIdToken(getIDToken);

          await axios.post(process.env.REACT_APP_API + '/line-liff-select',
            { idToken: getIDToken }
          ).then(res => {
            setFormData(prevData => ({
              ...prevData,
              pictureUrl: res.data.pictureUrl,
              displayName: res.data.displayName,
              email: res.data.email,
              telephone: res.data.telephone,
            }));

            if (res.data.st !== "") {
              setcheckLineProfileRegistered(1);
            }
            setcheckLineProfile(1);
          });
        }
      } catch (error) {
        logout();
        console.log(error);
      }
    };
    initLiff();
  }, []);

  async function registerProfile(status) {
    if (email === "" && telephone === "") {
      toast.error("Please type in your email or phone number.");
      return false;
    }

    let userInfo = {
      idToken: getIdToken,
      email: email,
      telephone: telephone,
      status: status,
    };

    axios.post(process.env.REACT_APP_API + '/line-liff-register',
      { userInfoFront: userInfo }
    ).then(res => {
      toast.success(res.data);
      setcheckLineProfileRegistered(1);
    }).catch(err => {
      console.log(err.response.data.msg);
    });
  }

  function logout() {
    if (liff.isLoggedIn()) {
      liff.logout();
      liff.closeWindow();
      window.location.reload();
    }
  }

  if (checkLineProfile !== 0) {
    return (
      <>
        <div className="liff-root">
          <div className="liff-card">

            {/* ── Hero ── */}
            <div className="liff-hero">
              <div className="liff-avatar-wrap">
                <img
                  src={pictureUrl}
                  alt={displayName}
                  className="liff-avatar"
                />
                {checkLineProfileRegistered !== 0 && (
                  <div className="liff-badge-verified" title="Registered">
                    {/* checkmark icon */}
                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="8" fill="#06c755"/>
                      <path d="M4.5 8.5l2.5 2.5 4.5-5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                )}
              </div>

              <p className="liff-display-name">{displayName}</p>

              <span className="liff-status-pill">
                {checkLineProfileRegistered !== 0 ? '✓ Registered' : 'Not registered yet'}
              </span>
            </div>

            {/* ── Body ── */}
            <div className="liff-body">
              <p className="liff-section-label">Contact Information</p>

              <div className="liff-field">
                <label htmlFor="email">Email address</label>
                <input
                  className="liff-input"
                  value={email}
                  onChange={e => onChange(e)}
                  type="text"
                  id="email"
                  name="email"
                  placeholder="example@email.com"
                  required
                />
              </div>

              <div className="liff-field">
                <label htmlFor="telephone">Phone number</label>
                <input
                  className="liff-input"
                  value={telephone}
                  onChange={e => onChange(e)}
                  type="text"
                  id="telephone"
                  name="telephone"
                  placeholder="0812345678"
                  required
                />
              </div>

              <div className="liff-actions">
                {checkLineProfileRegistered === 0 ? (
                  <button
                    className="liff-btn liff-btn-primary"
                    onClick={() => registerProfile('regis')}
                  >
                    {/* LINE icon */}
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <path d="M9 1.5C4.86 1.5 1.5 4.36 1.5 7.875c0 3.128 2.778 5.748 6.534 6.24.254.055.6.168.688.385.079.198.052.508.025.708l-.112.672c-.034.2-.158.783.686.427.843-.357 4.554-2.682 6.21-4.594C16.82 10.39 16.5 9.168 16.5 7.875 16.5 4.36 13.14 1.5 9 1.5z" fill="#fff"/>
                    </svg>
                    Register &amp; get messages
                  </button>
                ) : (
                  <button
                    className="liff-btn liff-btn-warning"
                    onClick={() => registerProfile('update')}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M11.333 2a1.333 1.333 0 0 1 1.886 1.886L4.667 12.438l-2.334.448.448-2.334L11.333 2z" stroke="#fff" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Update profile
                  </button>
                )}

                <div className="liff-divider" />

                <button
                  className="liff-btn liff-btn-ghost"
                  onClick={logout}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M6 14H3.333A1.333 1.333 0 0 1 2 12.667V3.333A1.333 1.333 0 0 1 3.333 2H6M10.667 11.333 14 8l-3.333-3.333M14 8H6" stroke="#ef4444" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Log out
                </button>
              </div>
            </div>

          </div>
        </div>
      </>
    );
  }

  return null;
}
